import React from "react";
import { Button } from "@src/components/elements";
import { GustoLogo } from "@src/components/elements/assets/GustoLogo";
import { IntegrationSection } from "@src/pages/settings/Integrations/IntegrationSection";

export const GustoIntegrationSection = ({
  hrIntegrations,
}: {
  hrIntegrations: { id: string }[];
}) => (
  <IntegrationSection
    title="Gusto"
    logo={<GustoLogo />}
    isConnected={!!hrIntegrations.length}
    actionComponents={
      <Button
        variant="primary"
        onClick={() => (location.href = "/auth/gusto/login")}
        disabled={!!hrIntegrations.length}
      >
        Connect
      </Button>
    }
    descriptionComponent={
      <p>Enable headcount planning and tracking with the Gusto integration.</p>
    }
  />
);
